import { ReactNode } from 'react';
import { Accordion, Badge } from '@round/creatorbase-ui';
import styles from './ClassifiedSection.module.css';

type Props = {
    value: string;
    title: string;
    count: number;
    children: ReactNode;
};

const ClassifiedSection = ({ value, title, count, children }: Props) => (
    <Accordion.Item value={value}>
        <Accordion.Trigger className={styles.trigger}>
            <span className={styles.triggerInner}>
                <span>{title}</span>
                <Badge size="sm" variant="secondary">
                    {count}
                </Badge>
            </span>
        </Accordion.Trigger>

        <Accordion.Content className={styles.content}>{children}</Accordion.Content>
    </Accordion.Item>
);

export default ClassifiedSection;
